import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useModifiers(env, client) {
  const [loadedModifiers, setLoadedModifiers] = useState(false);
  const [modifiers, setModifiers] = useState(null);

  useEffect(() => {
    setLoadedModifiers(false);
    if (!client) {
      setLoadedModifiers(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "modifiers");
    
    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setModifiers(data);
      setLoadedModifiers(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedModifiers, modifiers };
}